import React, { useState, useEffect } from 'react'
import { Link } from 'react-router-dom'


const ServiceSidebar = (props) => {
    const [services, setServices] = useState([]);

    useEffect(() => {
        const fetchServices = async () => {
            try {
                const res = await fetch('/api/services');
                const data = await res.json();
                setServices(Array.isArray(data) ? data : []);
            } catch (error) {
                console.error('Error fetching services:', error);
                setServices([]);
            }
        };
        fetchServices();
    }, []);

    const ClickHandler = () => {
        window.scrollTo(10, 0);
    }

    return (
        <div className="service-sidebar">
            <div className="service-catagory">
                <ul>
                    {services.slice(0, 5).map((service, item) => (
                        <li key={service.id || item}>
                            <Link onClick={ClickHandler} to={`/service-single/${service.slug}`}>
                                <i className={service.icon}></i>{service.title}</Link>
                        </li>
                    ))}
                </ul>
            </div>
            <div className="service-info">
                <div className="icon">
                    <i className="flaticon-phone-call"></i>
                </div>
                <h2>Have any
                    questions?
                    Reach out!</h2>
                <span>Email us</span>
                <div className="num">
                    <span>info@pcic.org.au</span>
                </div>
                <span style={{marginTop: '10px', display: 'block'}}>Call us</span>
                <div className="num">
                    <span>+61 400 000 000</span>
                </div>
            </div>
        </div>
    )
}

export default ServiceSidebar;
